import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/logo-login.png'


const _withScopeId = n => (_pushScopeId("data-v-147c2c71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "box-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"70%"},
  src: _imports_0,
  preview: false
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "box-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Acesso ao Sistema",
      preview: false
    })
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "content-success"
}
const _hoisted_8 = {
  key: 1,
  class: "content-success"
}
const _hoisted_9 = {
  key: 2,
  class: "content-success"
}
const _hoisted_10 = {
  key: 3,
  class: "content-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.isLoadPage) + " ", 1),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      (_ctx.isLoadPage)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _createVNode(_component_a_result, {
              status: "info",
              title: "Verificando o Cadastro",
              "sub-title": "Estamos Verificando seu cadastro!",
              class: "active-account-info"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_ExclamationCircleFilled, { class: "info-ic" })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuccessActiveAccount && !_ctx.isLoadPage)
        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _createVNode(_component_a_result, {
              status: "success",
              title: "Verificado com sucesso.",
              "sub-title": "Você será redirecionado para a página de cadastro!",
              class: "active-account-success"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_CheckCircleFilled, { class: "success-ic" })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isSuccessActiveAccount && !_ctx.isLoadPage)
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _createVNode(_component_a_result, {
              status: "error",
              title: "Falha ao ativar a conta.",
              "sub-title": "Por favor verfique o link de acesso!",
              class: "active-account-error"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_CloseCircleFilled, { class: "error-ic" })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
            _createVNode(_component_Footer)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}